import { useAuth0 } from '@auth0/auth0-react';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { queryKeys } from '@queries/keys';
import { useQuery } from '@tanstack/react-query';
import { KillChainSelectDto, KillChainsSelectDto } from '../types/api.types';

export const useGetKillChains = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = Boolean(isAuthenticated);

  return useQuery<KillChainSelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<KillChainsSelectDto>({
        path: '/v1/data/kill-chains',
      });
      return result.killChains;
    },
    queryKey: enabled ? queryKeys.killChain.getKillChains : queryKeys.placeholders.default,
  });
};
